'use strict';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import Backbutton from '../../BackButton';
import {
    StyledParentalControl,
    StyledParentalControlHeading,
    StyledParentalControlInner,
} from './ParentalControl.styles';
import ParentalControlDefault from './ParentalControlDefault';
import ParentalControlLock from './ParentalControlLock';

class ParentalControl extends Component {
    constructor(props) {
        super(props);
        this.onPlay = this.onPlay.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return (
            nextProps.videoId !== this.props.videoId ||
            this.props.parentalLockCode !== nextProps.parentalLockCode
        );
    }

    onPlay() {
        this.props.videoPlayer.play();
        this.props.confirmParentalLock();
    }

    render() {
        return (
            <>
                <Backbutton>Tillbaka</Backbutton>
                <StyledParentalControl>
                    <StyledParentalControlInner
                        role="alertdialog"
                        tabIndex="0"
                        aria-labelledby={`playParentalControl_title-${this.props.videoId}`}
                    >
                        <StyledParentalControlHeading id={`playParentalControl_title-${this.props.videoId}`}>
                            Detta program är olämpligt för barn
                        </StyledParentalControlHeading>
                        {this.props.parentalLockCode ? (
                            <ParentalControlLock code={this.props.parentalLockCode} onPlay={this.onPlay} />
                        ) : (
                            <ParentalControlDefault onPlay={this.onPlay} settingsUrl="/installningar" />
                        )}
                    </StyledParentalControlInner>
                </StyledParentalControl>
            </>
        );
    }
}

ParentalControl.propTypes = {
    videoId: PropTypes.string,
    parentalLockCode: PropTypes.string,
};

export default ParentalControl;
